import { TableFilters, TableFiltersWithSort, TABLE_COLUMN } from '../../filter-table-types';

/**
 * Returns an object with restored NEXT_GENERATE_AT filter data
 * @param data - Filter data from local storage
 */
export const getRestoredNextGenerateAtFilter = (data: TableFiltersWithSort) => {
  const newSavedNextGenerateAtFromDate = data.filters[TABLE_COLUMN.NEXT_GENERATE_AT]?.fromDate;
  const newNextGenerateAtToDate = data.filters[TABLE_COLUMN.NEXT_GENERATE_AT]?.toDate;
  return {
    [TABLE_COLUMN.NEXT_GENERATE_AT]: {
      ...data.filters[TABLE_COLUMN.NEXT_GENERATE_AT],
      fromDate: newSavedNextGenerateAtFromDate ? new Date(newSavedNextGenerateAtFromDate) : undefined,
      toDate: newNextGenerateAtToDate ? new Date(newNextGenerateAtToDate) : undefined
    }
  };
};

/**
 * Returns an object with restored SAVED_ON filter data
 * @param data - Filter data from local storage
 */
export const getRestoredSavedOnFilter = (data: TableFiltersWithSort) => {
  const newSavedOnDateFromDate = data.filters[TABLE_COLUMN.SAVED_ON]?.fromDate;
  const newSavedOnDateToDate = data.filters[TABLE_COLUMN.SAVED_ON]?.toDate;
  return {
    [TABLE_COLUMN.SAVED_ON]: {
      ...data.filters[TABLE_COLUMN.SAVED_ON],
      fromDate: newSavedOnDateFromDate ? new Date(newSavedOnDateFromDate) : undefined,
      toDate: newSavedOnDateToDate ? new Date(newSavedOnDateToDate) : undefined
    }
  };
};

/**
 * Returns an object with restored filter data for the given table column
 * @param data - Filter data from local storage
 * @param column - Table column name
 */
export const getRestoredFilter = (data: TableFiltersWithSort, column: TABLE_COLUMN) => {
  // eslint-disable-next-line default-case
  switch (column) {
    case TABLE_COLUMN.NEXT_GENERATE_AT: {
      return getRestoredNextGenerateAtFilter(data);
    }
    case TABLE_COLUMN.SAVED_ON: {
      return getRestoredSavedOnFilter(data);
    }
  }
};

/**
 * Returns an object with restored filter data for the given table columns
 * @param data - Filter data from local storage
 * @param columns - Table column names
 */
export const getRestoredFilters = (data: TableFiltersWithSort, columns: TABLE_COLUMN[]): Partial<TableFilters> => {
  const output = {};

  columns.forEach(col => {
    Object.assign(output, getRestoredFilter(data, col));
  });

  return output;
};
